export const themeConfig = {
    colorWhite: "#ffffff",
    colorLight: "#f8f8f8",
    border: "1px solid #BABFC7",
};
